export const AppRouters = {
    home: "/",
    newReport: "/new-request",
    signIn: '/sign-in',
    myRequestWithError: '/error/:error/:request?',
    auth: "/usuario/login/:ticket",
    confirmWizardReport: "/validar-usuario/:ticket/reporte/:reportId",
    continueReportCheckout: "/confirmar-reporte",
    incompletePaymentError: "/error/INCOMPLETE_PAYMENT",
    expiredPaymentError: "/error/EXPIRED_PAYMENT",
    satisfactoryPayment: "/satisfactoryPayment",
    withTicketSignDocuments: "/sign-documents/:ticket",
    previewUnSignedDocument: "/preview-un-signed-document/:id",
    signDocuments: "/sign-documents",
    myProfile: '/perfil',
    myDocs: '/documents',
    documentDetail: '/document/:id'
};

export default AppRouters;
